import { PartnerDetailsType } from '~/campaigns/types/campaign.types'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SVGImage from '~/components/Image/SVGImage'

export default function PartnerLogo({
  partnerDetails,
}: {
  partnerDetails: PartnerDetailsType
}): React.ReactElement | null {
  const { logoType } = partnerDetails?.logo || {}

  if (logoType === 'svgIcon' && partnerDetails?.logo?.svgIcon) {
    return (
      <SVGIcon
        className={partnerDetails.logo.className}
        icon={partnerDetails.logo.svgIcon}
        pathClassName={partnerDetails.logo.pathClassName}
        size={partnerDetails.logo.logoSize}
      />
    )
  } else if (logoType === 'svgImage' && partnerDetails?.logo?.src) {
    return (
      <SVGImage
        height={partnerDetails.logo.logoHeight}
        imageClassName={partnerDetails.logo.className}
        srcKey={partnerDetails.logo.src}
        width={partnerDetails.logo.logoWidth}
      />
    )
  } else if (logoType === 'awsImage' && partnerDetails?.logo?.src) {
    return (
      <ResponsiveImage
        className={partnerDetails.logo.className}
        fetchPriority="high"
        fit="contain"
        height={partnerDetails.logo.logoHeight}
        imageClassName={partnerDetails.logo.imageClassName}
        loading="eager"
        srcKey={partnerDetails.logo.src}
      />
    )
  } else {
    return null
  }
}
